import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { confirmarPago } from "../services/api";

function PagoExitoso() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState("procesando"); // "procesando" | "ok" | "error"

  useEffect(() => {
    const status    = searchParams.get("status") || searchParams.get("collection_status");
    const paymentId = searchParams.get("payment_id") || searchParams.get("collection_id");
    const ventaId   = localStorage.getItem("ventaId");

    if (!ventaId) {
      setEstado("ok");
      localStorage.removeItem("carrito");
      return;
    }

    confirmarPago(ventaId, status || "approved", paymentId)
      .then(() => {
        localStorage.removeItem("ventaId");
        localStorage.removeItem("carrito");
        setEstado("ok");
      })
      .catch(() => setEstado("error"));
  }, [searchParams]);

  if (estado === "procesando") return <p style={styles.msg}>Confirmando tu pago...</p>;

  if (estado === "error") return (
    <div style={styles.container}>
      <h2 style={{ color: "red" }}>Hubo un problema</h2>
      <p>No pudimos confirmar tu pago. Contacta a soporte.</p>
      <button style={styles.btn} onClick={() => navigate("/")}>Volver al inicio</button>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.icono}>✅</div>
      <h2>¡Pago exitoso!</h2>
      <p>Tu pedido fue registrado correctamente. Te contactaremos cuando sea despachado.</p>
      <button style={styles.btn} onClick={() => navigate("/")}>Seguir comprando</button>
    </div>
  );
}

const styles = {
  container: { maxWidth: 480, margin: "80px auto", textAlign: "center", padding: "0 16px" },
  icono:     { fontSize: 64, marginBottom: 16 },
  msg:       { textAlign: "center", marginTop: 80, fontSize: 18 },
  btn: {
    marginTop: 24, padding: "12px 32px", backgroundColor: "#1a1a2e",
    color: "#fff", border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer"
  }
};

export default PagoExitoso;
